import { jsPDF } from 'jspdf';
import { fileUrlToBase64 } from 'utils';
import { editageImage } from './editageImage.js';
import { mindTheGraphImage } from './mindTheGraphImage.js';

export default async function createInvoicePdfChina(invoice, profile, email) {
  const plan = invoice.formattedPlan === 'undefined undefined' ? 'Upsell' : invoice.formattedPlan;
  const date = invoice.formattedDate;
  let price = invoice.total;
  const name = profile.name;
  const institution = profile.institution;
  const unitPrice = parseInt(price);
  price = addZeroes(price);

  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  const hours = today.getHours();
  const minutes = today.getMinutes();
  const seconds = today.getSeconds();

  if (dd < 10) {
    dd = `0 ${dd}`;
  }
  if (mm < 10) {
    mm = `0 ${mm}`;
  }

  today = `${mm}/${dd}/${yyyy} ${hours}:${minutes}:${seconds}`;

  function getPlan(plan) {
    switch (plan) {
      case 'Monthly Student Subscription':
        return { text: '学生月付计划', unitPrice: 35.85, vat: '2.15' };
      case 'Quarterly Student Subscription':
        return { text: '学生季度订阅', unitPrice: 83.02, vat: '4.98' };
      case 'Yearly Student Subscription':
        return { text: '学生年度订阅', unitPrice: 282.08, vat: '16.92' };
      case 'Monthly Researcher Subscription':
        return { text: '研究员月度订阅', unitPrice: 64.15, vat: '3.85' };
      case 'Quarterly Researcher Subscription':
        return { text: '研究员季度订阅', unitPrice: 178.3, vat: '10.70' };
      case 'Yearly Researcher Subscription':
        return { text: '研究员年度订阅', unitPrice: 659.43, vat: '39.57' };
      case 'Monthly Lab Researcher Subscription':
        return { text: '实验室研究员月度订阅', unitPrice: 376.42, vat: '22.58' };
      case 'Yearly Lab Researcher Subscription':
        return { text: '实验室研究员年度订阅', unitPrice: 2829.25, vat: '169.75' };
      default:
        return plan;
    }
  }

  const planInfo = getPlan(plan);
  const doc = new jsPDF();

  // add chinese font
  const chineseFont = await fileUrlToBase64('/fonts/NotoSansSC-VariableFont_wght.ttf');
  doc.addFileToVFS('NotoSansTC.ttf', chineseFont.content);
  doc.addFont('NotoSansTC.ttf', 'NotoSansTC', 'normal');
  doc.setFont('NotoSansTC');

  const notoSans = 'NotoSansTC';

  // Logo image
  doc.addImage(mindTheGraphImage, 'PNG', 10, 10, 34, 11);
  doc.addImage(editageImage, 'PNG', 160, 10, 34, 11);

  // Line
  doc.setLineWidth(0.2);
  doc.line(10, 25, 200, 25);

  // MtG informations
  doc.setFontSize(12);
  doc.setFont(notoSans);
  doc.text(10, 40, '开科思（上海）商务信息咨询有限公司');
  doc.setFont(notoSans);
  doc.text(10, 45, '上海市浦东新区浦东大道720号国际');
  doc.text(10, 50, '航运金融大厦10楼A');
  doc.setFont(notoSans);
  doc.text(10, 65, '电子邮箱: mtg@editage.cn');
  doc.line(10, 70, 100, 70);
  doc.text(90, 75, 'Seller');

  // User informations
  doc.setFont(notoSans);
  doc.text(120, 80, name);
  doc.setFont(notoSans);
  doc.text(120, 85, `电子邮箱: ${email}`);
  if (institution) doc.text(120, 90, institution);
  doc.line(120, 95, 200, 95);
  doc.text(185, 100, 'Buyer');

  // Invoice number (b)
  doc.setFont(notoSans);
  doc.text(10, 105, `收据号 ${invoice.id}`);
  // Invoice date (b)
  doc.setFont(notoSans);
  doc.text(10, 110, `收据开具时间 ${today}`);

  // Issue date (payment_date)
  // doc.setFont(notoSans);
  // doc.text(10, 125, `账号开通时间: ${date}`);
  // Sell date (payment_date)
  // doc.text(10, 130, `服务购买时间: ${date}`);

  // Annual Subscription
  doc.setFont(notoSans);
  doc.text(10, 150, planInfo.text);

  // Item      VAT  Qty  Unit net price  Discount  Total net  VAT amoun  Total Gross
  doc.text(10, 160, '明细');
  doc.text(55, 160, '增值税');
  doc.text(75, 160, '数量');
  doc.text(94, 160, '单价');
  doc.text(115, 160, '折扣');
  doc.text(138, 160, '未税价');
  doc.text(159, 160, '增值税');
  doc.text(183, 160, '应付金额');
  doc.setFont(notoSans);

  // Line
  doc.line(10, 165, 200, 165);

  // Item      VAT  Qty  Unit net price  Discount  Total net  VAT amoun  Total Gross
  doc.text(10, 170, 'Mind the Graph');
  doc.text(10, 175, planInfo.text);
  doc.text(58, 170, '6%');
  doc.text(78, 170, '1');
  doc.text(89, 170, `￥ ${planInfo.unitPrice}`);
  doc.text(116, 170, '0%');
  doc.text(137, 170, `￥ ${planInfo.unitPrice}`);
  doc.text(161, 170, planInfo.vat);
  doc.text(182, 170, `￥ ${price}`);

  // Line
  doc.line(10, 177, 200, 177);

  // Total
  doc.setFont(notoSans);
  doc.text(82, 182, '合计');
  doc.setFont(notoSans);
  doc.text(108, 182, `￥ ${price}`);

  // Total Payments: USD price (b)
  doc.setFont(notoSans);
  doc.setFontSize(20);
  doc.text(90, 210, `应付金额: ￥ ${price}`);
  doc.save(`mtg-invoice-${today}.pdf`);
}

function addZeroes(num) {
  let value = Number(num);
  let res = num.toString().split('.');
  if (num.toString().indexOf('.') === -1) {
    value = value.toFixed(2);
    num = value.toString();
  } else if (res[1].length < 3) {
    value = value.toFixed(2);
    num = value.toString();
  }
  return num;
}
